<template>
  <div class="asc-customAlerts--noData">
    <asc-accent-button
      button-text="Create Custom Analytic"
      :on-click="handleAddCustomAlert"
      :outline="true"
      :secondary="true"
      :block="true"
    ></asc-accent-button>
    <p>
      You currently have no custom analytics.<br />Click Create Custom Analytic
      to quickly set and manage custom thresholds for component parameters.
    </p>
  </div>
</template>

<script>
import AscAccentButton from './AscAccentButton'

export default {
  name: 'AscCustomAlertsNoData',

  components: {
    AscAccentButton,
  },

  methods: {
    handleAddCustomAlert() {
      this.$emit('openAlertTypeDialog')
    },
  },
}
</script>

<style lang="scss">
.asc-customAlerts--noData {
  background: $primary-white;
  display: flex;
  flex-direction: column;

  p {
    margin: 10% auto 0 auto;
    text-align: center;
    font-size: 14px;
  }
}
</style>
